export enum MART_CATEGORY_REQUEST_ID_LIST {
  GET_MART_TAG = 'GET_MART_TAG',
  GET_MART_CATEGORY = 'GET_MART_CATEGORY',
  POST_MART_CATEGORY = 'POST_MART_CATEGORY',
  DELETE_MART_CATEGORY = 'DELETE_MART_CATEGORY',
  CALL_MART_CATEGORY_TNC = 'CALL_MART_CATEGORY_TNC',
  GET_MASTER_MART_CATEGORY = 'GET_MASTER_MART_CATEGORY',
  POST_TRANSFER_MART_CATEGORY = 'POST_TRANSFER_MART_CATEGORY'
}

export enum MART_CATEGORY_TRANSLATION_KEY {
  PRODUCT_CATEGORY_NOT_FOUND = 'productCategory.notFound',
}

export enum MART_TRANSLATION_KEY {
  PRODUCT_NOT_FOUND = 'product.notFound',
}

export enum MART_CATEGORY_GROUPING_ID {
  PROMOTION = 1,
  NORMAL = 2
}
